import css from 'styled-jsx/css';

const styles = css.global`.accordion {
  display: flex;
  flex-direction: column;
}

.accordion .acc-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 28px;
  cursor: pointer;
}

.accordion .acc-head p {
  font-family: SantanderText;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #222;
  pointer-events: none;
}

.accordion .acc-head .acc-arrow {
  pointer-events: none;
  transform: rotate(180deg);

  transition: transform 150ms ease;
}

.accordion.open .acc-head .acc-arrow {
  transform: rotate(0deg);
}

.accordion .acc-body {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 250ms ease;
}

.accordion.open .acc-body {
  grid-template-rows: 1fr;
}

/* .accordion .acc-body-inner {
  overflow: hidden;
}

.accordion.open .acc-body-inner {
  overflow: visible;
} */
`;

export default styles;